import type { SVGProps } from 'react';
const SvgIconLodgeFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
    <path
      fill="#3E704B"
      fillRule="evenodd"
      d="M22.995 12.872c0 .625-.521 1.115-1.111 1.115h-1.112l.025 5.563q0 .14-.018.281v.56c0 .767-.621 1.388-1.389 1.388h-.555q-.058 0-.115-.003-.073.004-.146.003h-1.962a1.39 1.39 0 0 1-1.389-1.389v-3.056a1.11 1.11 0 0 0-1.11-1.11H11.89a1.11 1.11 0 0 0-1.112 1.11v3.056c0 .768-.621 1.39-1.389 1.39H7.448q-.078-.001-.156-.008a2 2 0 0 1-.125.007h-.556a1.39 1.39 0 0 1-1.389-1.389v-3.889q-.001-.048.004-.097v-2.417H4.11A1.1 1.1 0 0 1 3 12.872c0-.312.104-.59.347-.833l8.904-7.761c.243-.243.52-.278.764-.278.243 0 .52.07.729.243l8.869 7.796c.278.243.416.52.382.833"
    />
  </svg>
);
export default SvgIconLodgeFilled;
